module.exports = __webpack_public_path__ + "static/media/stefan_teisanu.d9915375.png";